<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="用户ID" prop="id">
            <el-input style="width: 232px" v-model="searchForm.id" placeholder="请输入用户ID" clearable></el-input>
          </el-form-item>
          <el-form-item label="用户昵称" prop="nickName">
            <el-input style="width: 232px" v-model="searchForm.nickName" placeholder="请输入用户昵称"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="mobile">
            <el-input style="width: 232px" v-model="searchForm.mobile" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <!-- <el-form-item label="用户等级" prop="brandId">
            <el-select
              v-model="searchForm.brandId"
              placeholder="请选择用户等级"
              filterable
              clearable
            >
              <el-option
                v-for="item in brandList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="用户等级" prop="vipLevelId">
            <el-select style="width: 232px" v-model="searchForm.vipLevelId" placeholder="请选择用户等级" filterable clearable>
              <el-option v-for="item in levelList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否购买商品" prop="isBuy">
            <el-select style="width: 232px" v-model="searchForm.isBuy" placeholder="请选择" filterable clearable>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="生成时间" prop="joinTimeStart">
            <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>

          <el-form-item class="form-btn">
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button type="primary" icon="el-icon-upload2" :loading="exporting" @click="exportFn">批量导出</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage" :page-size="page.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data() {
    return {
      lists: [],
      name: '',
      isUser: false,
      isRecord: false,
      isBind: false,
      isChange: false,
      records: [
        {
          time: '2023-12-12 10:20:02',
          avatar: 'https://fenxiao.muruji.com/b4908f91ff7c4c75bb4bfd3f920709cc/6cdbbf91-4e0e-46c1-84c2-d03736b13e6b',
          name: 'cdd',
          id: '7777',
          phone: '150111111111'
        },
        {
          time: '2023-12-12 10:20:02',
          avatar: 'https://fenxiao.muruji.com/b4908f91ff7c4c75bb4bfd3f920709cc/6cdbbf91-4e0e-46c1-84c2-d03736b13e6b',
          name: 'cdd',
          id: '7777',
          phone: '150111111111'
        },
        {
          time: '2023-12-12 10:20:02',
          avatar: 'https://fenxiao.muruji.com/b4908f91ff7c4c75bb4bfd3f920709cc/6cdbbf91-4e0e-46c1-84c2-d03736b13e6b',
          name: 'cdd',
          id: '7777',
          phone: '150111111111'
        },
      ],
      dataList: {
        list: [
          { title: '用户管理', path: '', type: '0' },
          { title: '用户列表', path: '/userManagement/userList', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '用户列表', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      list: [],
      searchForm: {
        nickName: '', //
        mobile: '', //
        level: '', //
        isBuy: '', //
        createTimeStart: '', //
        createTimeEnd: '', //
        id: '', //
        pageNo: 1,
        pageSize: 10,
        vipLevelId: '',
      },
      searchForm1: {
        userId: '', //
        nickName: '', //
        phone: '', //
        hasShopping: '', //
        joinTimeStart: '', //
        joinTimeEnd: '', //
        lastActiveTimeStart: '', //
        lastActiveTimeEnd: '', //
        bindTimeStart: '',
        bindTimeEnd: ''
      },
      value1: [],
      value2: [],
      value3: [],
      brandList: [],
      columns: [
        { type: 'selection', minWidth: '80', },
        // {
        //   label: '用户信息', prop: 'username', minWidth: '222',
        //   renderHeader: (h, scope) => {
        //     return (
        //       <div style="text-align:left">用户信息</div>
        //     )
        //   },
        //   render: (h, scope) => {
        //     let img = scope.row.avatarUrl ? scope.row.avatarUrl : require('../../../assets/icon_touxiang_106@2x.png')
        //     return (
        //       <div style="display:flex">
        //         <div>
        //           <el-image style="width:64px;height:64px;border-radius:50%;" src={img} preview-src-list={[img]} lazy></el-image>
        //         </div>
        //         <div style="margin-left:8px">
        //           <div style="text-align:left">昵称：{scope.row.username || '--'}</div>
        //           <div style="text-align:left">ID：{scope.row.id || '--'}</div>
        //           <div style="text-align:left">电话：{scope.row.phone || '--'}</div>
        //         </div>

        //       </div>
        //     )
        //   }
        // },
        { label: '用户ID', prop: 'id' },
        { label: '用户昵称', prop: 'nickName' },
        {
          label: '用户头像', prop: 'avatarUrl',
          render: (h, scope) => {
            let img = scope.row.avatarUrl ? scope.row.avatarUrl : require('../../../assets/icon_touxiang_106@2x.png')
            return (
              <div>
                <el-image style="width:64px;height:64px;border-radius:50%;" src={img} preview-src-list={[img]} lazy></el-image>
              </div>
            )
          }
        },

        { label: '用户等级', prop: 'vipLevelName' },
        { label: '手机号码', prop: 'phone' },
        { label: '余额', prop: 'balance' },
        {
          label: '生成时间', prop: 'createTime', minWidth: '150',
          render: (h, scope) => {
            let createTime = scope.row.createTime ? scope.row.createTime : '--'
            return (
              <div style="text-align:center">
                <span>{createTime}</span>
              </div >
            )
          }
        },
        // { label: '拥有粉丝数', prop: 'fansCount', minWidth: '100' },
        // { label: '可提现佣金', prop: 'commission', minWidth: '100' },
        { label: '购物状态', prop: 'repurchaseTypeLabel', minWidth: '100' },

        { label: '是否购买过商品', prop: 'isBuyLabel', minWidth: '120' },
        {
          label: '操作',
          minWidth: '150',

          render: (h, scope) => {
            return (
              <div>
                <el-button type='text' onClick={() => { this.todetail('edit', scope.row) }}>查看</el-button>

              </div >
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      exporting: false,
      currentData: {},
      selectData: {},
      selectData1: {},
      levelList: []
    }
  },
  created() {
    this.getPageList()
    this.getLevel()
  },
  methods: {
    getLevel() {
      this.axios.get('/vip/level/getUserLevelDataList')
        .then(res => {
          console.log('等级', res)
          if (res.code == 0) {
            this.levelList = res.data
          }
        })
    },
    submitBind() {
      if (!this.selectData1.id) {
        this.$message.warning('请选择绑定上级')
        return
      }
      let data = {
        parentId: this.selectData1.id,
        userId: this.currentData.id
      }
      this.axios.post('/admin/changeBind', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$message.success('换绑成功')
            this.isBind = false
            // this.searchForm.username = ''
            this.getPageList()
          }
        })
    },
    deleteS() {
      this.isChange = false
      this.selectData1 = {}
    },
    bindSave() {
      this.selectData1 = this.selectData
      this.isUser = false
      this.isChange = true
    },
    selectBind(index) {
      for (let i = 0; i < this.lists.length; i++) {
        if (i == index) {
          this.lists[index].isShow = !this.lists[index].isShow
        } else {
          this.lists[i].isShow = false
        }
      }
      this.selectData = this.lists[index]
    },
    searchUser(val) {
      // this.$refs['searchForm'].resetFields()
      // this.value1 = []
      // this.value2 = []
      // this.searchForm.joinTimeStart = ''
      // this.searchForm.joinTimeEnd = ''
      // this.searchForm.lastActiveTimeStart = ''
      // this.searchForm.lastActiveTimeEnd = ''
      // this.searchForm.bindTimeStart = ''
      // this.searchForm.bindTimeEnd = ''
      this.isUser = true
      this.searchForm1.pageNo = 1;
      this.searchForm1.pageSize = 10000000;
      if (val == 'reset') {
        this.name = ''
      }
      this.searchForm1.username = this.name
      if (this.name == '') {
        this.lists = []
        return

      }
      this.axios.post('/users/getPageList', this.searchForm1)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            res.data.list.forEach(item => {
              if (item.id == this.currentData.parent.id) {
                item.isShow = true
              } else {
                item.isShow = false
              }
            })
            this.lists = res.data.list;

          }
        })
    },
    handleCommand(e, row) {
      console.log(e)
      if (e == 'look') {
        this.todetail(row)
      } else if (e == 'change') {
        this.changeBind(row)
      } else if (e == 'record') {
        this.lookRecord(row)
      }
    },
    changeBind(row) {
      this.isBind = true
      this.name = ''
      this.selectData1.id = ''
      console.log(row)
      this.currentData = row
    },
    lookRecord(row) {
      this.isRecord = true
      let data = {
        userId: row.id
      }
      this.axios.get('/admin/changeBindLog?userId=' + row.id)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.records = res.data

          }
        })
    },
    exportFn() {
      this.exporting = true
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.createTimeStart = this.value1[0];
        this.searchForm.createTimeEnd = this.value1[1];
      } else {
        this.searchForm.createTimeStart = ''
        this.searchForm.createTimeEnd = ''
      }
      this.axios.post('/user/pageListExport', this.searchForm)
        .then(res => {
          console.log(res)
          this.exporting = false;
          if (res.code === 0) {
            this.downloadlink(res.data)
          }
        })
    },
    fetchData(type) {
      this.page.pageNo = 1;
      this.page.currentPage = 1;
      if (type == 'reset') {
        this.$refs['searchForm'].resetFields()
        this.value1 = []
        this.searchForm.createTimeStart = ''
        this.searchForm.createTimeEnd = ''
      }
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.createTimeStart = this.value1[0];
        this.searchForm.createTimeEnd = this.value1[1];
      } else {
        this.searchForm.createTimeStart = ''
        this.searchForm.createTimeEnd = ''
      }
      this.getPageList()
    },
    getPageList() {
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.createTimeStart = this.value1[0];
        this.searchForm.createTimeEnd = this.value1[1];
      } else {
        this.searchForm.createTimeStart = ''
        this.searchForm.createTimeEnd = ''
      }

      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.axios.post('/user/pageList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {

            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    },
    onMultipleSelection(e) { },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getPageList()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getPageList()
    },
    todetail(type, row) {
      // console.log(row)
      // return
      this.$router.push({
        name: 'userDetail',
        query: {
          id: row.id
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.el-button--primary.is-disabled {
  background: #2D46EE;
  border: 1px solid #2D46EE;
}

.dropdown {
  background-color: red !important;
}

.change {
  width: 64px;
  height: 32px;
  background: #FFFFFF;
  border: 1px solid #2D46EE;
  opacity: 1;
  border-radius: 16px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 32px;
  color: #2D46EE;
  text-align: center;
  cursor: pointer;
}

.btn-y {
  width: 64px;
  height: 32px;
  background: #2D46EE;
  opacity: 1;
  border-radius: 16px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 32px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
}

.btn-s {
  width: 64px;
  height: 32px;
  background: #E9ECFE;
  opacity: 1;
  border-radius: 16px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 32px;
  color: #2D46EE;
  text-align: center;
  cursor: pointer;
}

.title-u {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 34px;
  color: #2D46EE;
}

.delete-u {
  width: 64px;
  height: 32px;
  background: #F63C56;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 32px;
  color: #FFFFFF;
  text-align: center;
  margin-top: 16px;
  opacity: 1;
  border-radius: 16px;
  cursor: pointer;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 37px;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }

  .form-btn {
    /deep/ .el-form-item__content {
      line-height: 36px;
      margin-left: 50px;
    }
  }
}

/deep/ .el-table__row {
  .el-table__cell {
    padding: 12px 0;
  }
}

/deep/ .el-table {
  color: #303033;
}
</style>
<style lang="scss">
.el-dropdown-menu .el-dropdown-menu__item:hover {
  background-color: white;
  color: #2D46EE;
}
</style>



